import { useState, useEffect } from 'react';
import { TypingHistory } from '../types';
import { getAllHistory, clearAllHistory } from '../db/indexedDB';

interface HistoryListProps {
  refreshTrigger?: number;
}

export function HistoryList({ refreshTrigger }: HistoryListProps) {
  const [history, setHistory] = useState<TypingHistory[]>([]);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    loadHistory();
  }, [refreshTrigger]);

  const loadHistory = async () => {
    setLoading(true);
    const data = await getAllHistory();
    setHistory(data);
    setLoading(false);
  };

  const handleClear = async () => {
    if (confirm('确定要清空所有历史记录吗？')) {
      await clearAllHistory();
      setHistory([]);
    }
  };

  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleString('zh-CN', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <>
      <button className="btn-header" onClick={() => setIsOpen(true)}>
        历史记录
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="modal-content modal-large"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2>练习历史</h2>
              <button className="btn-close" onClick={() => setIsOpen(false)}>
                ×
              </button>
            </div>

            <div className="history-content">
              {loading ? (
                <div className="loading">加载中...</div>
              ) : history.length === 0 ? (
                <div className="empty-state">暂无练习记录</div>
              ) : (
                <table className="history-table">
                  <thead>
                    <tr>
                      <th>时间</th>
                      <th>文章</th>
                      <th>WPM</th>
                      <th>准确率</th>
                      <th>错误</th>
                      <th>用时</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history.map((record) => (
                      <tr key={record.id}>
                        <td>{formatDate(record.createdAt)}</td>
                        <td className="article-cell" title={record.articleTitle}>
                          {record.articleTitle}
                        </td>
                        <td className="wpm-cell">{record.wpm}</td>
                        <td>{record.accuracy}%</td>
                        <td>{record.errorCount}</td>
                        <td>{record.duration}s</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {history.length > 0 && (
              <div className="modal-actions">
                <button className="btn-danger" onClick={handleClear}>
                  清空历史
                </button>
                <button
                  className="btn-secondary"
                  onClick={() => setIsOpen(false)}
                >
                  关闭
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
